'use client';

import { UseCasesCard } from '../types';

import { Button } from '@/shared/components/button';
import { Card } from '@/shared/components/card';
import { classNames } from '@/shared/lib/classNames/classNames';

interface Props {
  cards: UseCasesCard[];
}

export const UseCasesDesktopSection = ({ cards }: Props) => {
  return (
    <div className="flex h-[204px] gap-8 px-4 max-sm:hidden">
      {cards.map(({ id, description, icon, buttonHref, buttonLabel }) => {
        return (
          <Card key={id} rounded="16">
            <div
              className={classNames({
                cls: 'flex h-full flex-col justify-between p-6',
                mods: { [`basis-1/${cards.length}`]: true },
              })}
            >
              <p>{description}</p>
              <div className="flex justify-between">
                <div className="bg-surface-base-blur flex size-8 items-center justify-center rounded-lg">
                  {icon}
                </div>
                {buttonHref && (
                  <Button
                    href={buttonHref}
                    target="_blank"
                    variant="secondary"
                    className="h-[30px] items-center rounded-lg! py-0! text-[13px] leading-[14px] font-normal"
                  >
                    {buttonLabel}
                  </Button>
                )}
              </div>
            </div>
          </Card>
        );
      })}
    </div>
  );
};
